function initBundleDeal( )
{
    document.addEventListener( "click", handleBundleaATCClick );
    document.addEventListener( "click", handleBundleClick );
}

function handleBundleaATCClick( e )
{
    if ( e.target.matches( ".bundle-deal-atc" ) )
    {
        var inQuickAdd = false;
        if ( e.target.matches( ".quick-add__content .bundle-deal-atc" ) )
        {
            var inQuickAdd = true;
        }
        var input = document.querySelector( ".bundle-label .bundle-input:checked" );
        var itemQuantity = input.getAttribute( "value" );
        var variantId = input.dataset.variant;
        if ( variantId )
        {
            gtag( 'event', 'multibuy_add_to_cart' );

            let formData =
            {
                'items': 
                [
                    {
                        'id': variantId,
                        'quantity': itemQuantity
                    }
                ]
            };
            
            fetch( window.Shopify.routes.root + 'cart/add.js',
                {
                    method: 'POST',
                    headers:
                    {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify( formData )
                })
            .then( response =>
            {
                const cartDrawer = document.querySelector( 'cart-drawer' );
                const quickAdd = document.querySelector( 'quick-add-drawer' );
                if ( inQuickAdd === true )
                {
                    quickAdd.addedToCart( );
                    cartDrawer.refresh( true );
                }
                else
                {
                    cartDrawer.refresh( true );
                    cartDrawer.open( );
                }
                
                return response.json();
            })
            .catch( ( error ) =>
            {
                console.error( 'Error:', error );
            });
        }
        else
        {
            console.log( "No variant attribute, unable to add to cart." );
        }
    }
}

function handleBundleClick( e )
{
    //can't directly target label as inner element clicks won't be registered
    if ( e.target.closest( ".quick-add__content .bundle-label" ) && window.innerWidth < 769 )  
    {
        var atc = document.querySelector( ".quick-add__content .bundle-deal-atc" );
        atc.scrollIntoView( { behavior: "smooth", block: "center", inline: "center" } );
    }
}

initBundleDeal( );